import "./Programs.module.css";
import Header from "@/reusable_sections/Header";
import LaCarteDuMoment from "./sections/LaCarteDuMoment";
import JoinUsTonight from "./sections/JoinUsTonight";
import SynthesisRequestForm from "./sections/SynthesisRequestForm";
import Footer from "@/reusable_sections/Footer";
export default function ProgramsPage() {
  return <div>
      <Header />
      <LaCarteDuMoment />
      <JoinUsTonight />
      <SynthesisRequestForm />
      <Footer />
    </div>;
}